module.exports = __webpack_public_path__ + "img/13.06b0f0da.jpg";